<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['calculation.columns']"></i>
                        Anzuzeigende Spalten
                    </legend>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label><b>PZN</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-name"
                                           v-model="config.pznName">
                                    <label class="form-check-label" for="pzn-name">
                                        Artikelname
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-menge-einheit"
                                           v-model="config.pznMengeEinheit">
                                    <label class="form-check-label" for="pzn-menge-einheit">
                                        Menge und Einheit
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-dar"
                                           v-model="config.pznDar">
                                    <label class="form-check-label" for="pzn-dar">
                                        Darreichungsform
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-anbieter"
                                           v-model="config.pznAnbieter">
                                    <label class="form-check-label" for="pzn-anbieter">
                                        Anbieter
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>BGA</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-name"
                                           v-model="config.bgaNameCity">
                                    <label class="form-check-label" for="bga-name">
                                        Name und Ort
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-dates"
                                           v-model="config.bgaDates">
                                    <label class="form-check-label" for="bga-dates">
                                        Start- und Enddatum
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-Out</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="verkauf-mwst"
                                           v-model="config.sellOutRemoveTax">
                                    <label class="form-check-label" for="verkauf-mwst">
                                        Mwst. herausrechnen
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['lager.salesMode']"></i>
                        Umsatzfilter
                    </legend>

                    <div class="form-group">
                        <label><b>Modus</b></label>
                        <select class="form-control" v-model="config.salesMode">
                            <option value="none">Deaktiviert</option>
                            <option value="sell-in">Sell-In</option>
                            <option value="sell-out">Sell-Out</option>
                        </select>
                    </div>

                    <div class="row" v-if="config.salesMode !== 'none'">
                        <div class="col">
                            <div class="form-group">
                                <label>Min</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Euro</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.salesMin">
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Max</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Euro</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.salesMax">
                                </div>
                            </div>
                        </div>
                    </div>

                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['lager.stockMode']"></i>
                        Bestandsfilter
                    </legend>

                    <div class="form-group">
                        <label><b>Modus</b></label>
                        <select class="form-control" v-model="config.stockMode">
                            <option value="none">Deaktiviert</option>
                            <option value="between">Lagerbestand zwischen</option>
                        </select>
                    </div>

                    <div class="row" v-if="config.stockMode === 'between'">
                        <div class="col">
                            <div class="form-group">
                                <label>Min</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Stück</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.stockMin">
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Max</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Stück</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.stockMax">
                                </div>
                            </div>
                        </div>
                    </div>

                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['lager.verfallMode']"></i>
                        Haltbarkeit
                    </legend>

                    <div class="form-group">
                        <label><b>Modus</b></label>
                        <select class="form-control" v-model="config.verfallMode">
                            <option value="all">Alle</option>
                            <option value="between">Frühester Verfall zwischen</option>
                        </select>
                    </div>

                    <div class="row" v-if="config.verfallMode === 'between'">
                        <div class="col">
                            <div class="form-group">
                                <label>Ab</label>
                                <div class="row">
                                    <div class="col">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Monat</span>
                                            </div>
                                            <input type="number" class="form-control" placeholder="01" v-model="config.verfallStartMonth">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Jahr</span>
                                            </div>
                                            <input type="number" class="form-control" placeholder="2022" v-model="config.verfallStartYear">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Bis</label>
                                <div class="row">
                                    <div class="col">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Monat</span>
                                            </div>
                                            <input type="number" class="form-control" placeholder="12" v-model="config.verfallEndMonth">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Jahr</span>
                                            </div>
                                            <input type="number" class="form-control" placeholder="2022" v-model="config.verfallEndYear">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['lager.anLagerMode']"></i>
                        Produkt an Lager
                    </legend>

                    <div class="form-group">
                        <label><b>Modus</b></label>
                        <select class="form-control" v-model="config.anLagerMode">
                            <option value="all">Alle</option>
                            <option value="yes">An Lager: Ja</option>
                            <option value="no">An Lager: Nein</option>
                        </select>
                    </div>

                </fieldset>

            </div>
        </div>

        <filtering-module :dto="config.filtering"
                          :options="options"
                          :warengruppen="true"
                          :dar="true"
                          :menge="true"
                          :wirkstoffe="true"
                          :reimport="false"></filtering-module>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../Modules/TimingPeriodModule";
import FilteringModule from "../Modules/FilteringModule";

export default {
    components: {FilteringModule, TimingPeriodModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
        };
    },
    methods: {},
    computed: {

    }
}
</script>
